import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">专题索引</h2>
          <p className="text-foreground-500 text-sm md:text-base">按话题分类，快速找到你关心的瓜</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexData.map((item, i) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center justify-between p-4 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer group animate-fade-in-up"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 font-heading font-bold text-sm">
                  {item.id}
                </span>
                <div>
                  <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </span>
                  <div className="text-xs text-foreground-400 mt-0.5">{item.count} 篇相关</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {item.tag && (
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold whitespace-nowrap ${
                    item.tag === '热门' || item.tag === '最新' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '深度' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '热议' ? 'bg-primary-50 text-primary-600' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                )}
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}